'use strict';
var ComponentList = require('./component-list'),
    ChildDefinition = require('./child-definition'),
    foreach = require('../utils/foreach');

/**
 * A child store class that manage the created childs of a component
 *
 * @param {Object} components
 * @param {Object} states
 * @constructor
 */
function ChildStore(components, states) {
    this._init(components, states);
}

ChildStore.prototype = {
    /**
     * The initializer of the class
     *
     * @param {Object} components
     * @param {Object} states
     * @private
     */
    _init: function (components, states) {
        var _this = this;

        this._data = {
            byCid: {},
            byName: {}
        };

        this.definition = new ChildDefinition(components, states);

        foreach(this.definition.getStates(), function (state, name) {
            _this.add(name, state);
        });
    },

    /**
     * Add a child to the store
     *
     * @param {string} name
     * @param {Component|Object} child
     */
    add: function (name, child) {
        var byName = this._data.byName,
            byCid = this._data.byCid;

        if (typeof child.cid !== 'undefined') {
            if (byCid[child.cid]) {
                return;
            }

            byCid[child.cid] = [child, name];
        }

        if (!byName[name]) {
            byName[name] = new ComponentList();
        }

        byName[name].push(child);
    },

    /**
     * Return a child from the store
     *
     * if the @param name is not defined, all the childs are returned
     * if @param byCid is true the child with the cid @param nameis returned
     * if @param name is defined and @param byCid is false the child defined with @param name is returned
     *
     * @param {string} [name]
     * @param {boolean} [byCid]
     * @returns {ComponentList|Component|Object|undefined} An object if the child is retreived, otherwise undefined
     */
    get: function (name, byCid) {
        var _this = this,
            child;
        if (typeof name === 'undefined') {
            child = {};
            foreach(this._data.byName, function (list, name) {
                child[name] = _this._getByName(name);
            });
        } else if (!byCid) {
            child = _this._getByName(name);
        } else {
            child = _this._getByCid(name);
        }

        return child;
    },

    /**
     *
     * @param {string} name
     * @returns {ComponentList|Component|Object|undefined} The child defined with @param name, otherwise undefined
     * @private
     */
    _getByName: function (name) {
        var child = this._data.byName[name];

        if (!this.definition.isComponentList(name) && child && child.length) {
            child = child && child[0];
        }

        return child;
    },

    /**
     *
     * @param {Component.cid} cid
     * @returns {Component|undefined} The component with the @param cid, otherwise undefined
     * @private
     */
    _getByCid: function (cid) {
        return this._data.byCid[cid] && this._data.byCid[cid][0];
    },

    /**
     * Remove the selected child from the store
     *
     * if the @param child is not defined, all the childs are removed
     * if @param child is a Component, that Component is removed
     * if @param child is a string, the childs are removed by their name
     *
     * @param {string|Component} [child]
     */
    remove: function (child) {
        var _this = this;

        if (!child) {
            foreach(this._data.byName, function (list, name) {
                if (_this.definition.isComponent(name)) {
                    _this._removeByName(name);
                }
            });
        } else if (typeof child === 'string') {
            this._removeByName(child);
        } else if (typeof child.cid !== 'undefined') {
            this._removeByCid(child.cid);
        }
    },

    /**
     * Remove the child @param name
     *
     * @param {string} name
     * @private
     */
    _removeByName: function (name) {
        var l = (this._data.byName[name] && this._data.byName[name].length) || 0,
            i, toDelete;

        for (i = l - 1; i >= 0; i--) {
            toDelete = this._data.byName[name][i];
            if (typeof toDelete.cid !== 'undefined') {
                toDelete.remove();
                delete this._data.byCid[toDelete.cid];
            }
        }

        delete this._data.byName[name];
    },

    /**
     * Remove the component that with the cid equals to @param cid
     *
     * @param {Component.cid} cid
     * @private
     */
    _removeByCid: function (cid) {
        var i, toDelete;

        if (this._data.byCid[cid]) {
            toDelete = this._data.byCid[cid][1];
            for (i = this._data.byName[toDelete].length - 1; i >= 0; i--) {
                if (this._data.byName[toDelete][i].cid === cid) {
                    this._data.byName[toDelete].splice(i, 1);
                    break;
                }
            }

            this._data.byCid[cid][0].remove();
            delete this._data.byCid[cid];
        }
    }
};

module.exports = ChildStore;

